import {
  PRIORITY_AXIS_EBIS,
  PRIORITY_AXIS_MEDIA_SYNC,
} from 'domain/consts';
import {
  FILTER_KEY_AD_GROUP1,
  FILTER_KEY_AD_GROUP2,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_NAME,
  FILTER_KEY_ADEBIFY_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_PURCHASED_PRODUCT,
  FILTER_KEY_CHANNEL_DISPLAY,
  FILTER_KEY_MEDIA,
  FILTER_KEY_MEDIA_ACCOUNT,
  FILTER_KEY_MEDIA_SIDE_CAMPAIGN,
  FILTER_KEY_MEDIA_SIDE_GROUP,
  TAB_ALL,
} from 'services/consts';

// Shared filter visibility rules for the Adebify (cart-integrated) reporting
// screens (Product Analysis, LTV Detail, LTV Cohort).
//
// Source of truth: adebify/docs/要件.md §456-480 (付録E) and §282-291
// (要件 14-2 traffic-mode rule).
//
// - Product filters are always available (購入商品 + 広告対象商品, each
//   exposing カテゴリ and 商品名).
// - 媒体 vs アドエビス filter families are mutually exclusive and follow the
//   axis toggle (priority_axis_media_sync vs priority_axis_ebis) on each
//   screen — same vocabulary as the rest of Redjug's reports.
// - チャネル種別 is exposed only in the 全トラフィック (TAB_ALL) tab.

export const PRODUCT_FILTERS = [
  FILTER_KEY_ADEBIFY_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_PURCHASED_PRODUCT,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_NAME,
];

export const PURCHASED_PRODUCT_FILTERS = [
  FILTER_KEY_ADEBIFY_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_PURCHASED_PRODUCT,
];

export const AD_PRODUCT_FILTERS = [
  FILTER_KEY_ADEBIFY_AD_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_NAME,
];

export const MEDIA_FILTERS = [
  FILTER_KEY_MEDIA_ACCOUNT,
  FILTER_KEY_MEDIA_SIDE_CAMPAIGN,
  FILTER_KEY_MEDIA_SIDE_GROUP,
];

export const ADEBIS_FILTERS = [
  FILTER_KEY_MEDIA,
  FILTER_KEY_AD_GROUP1,
  FILTER_KEY_AD_GROUP2,
];

// Build the allowed filter keys for an Adebify screen, gated by axis and tab.
// Pass the screen-specific axis from filterContext (each screen stores its own
// axis under a distinct key).
//
// Per 要件.md §524: 商品フィルタは「購入商品（カテゴリ/商品名）」と
// 「広告対象商品（カテゴリ/商品名）」の両方を常時使用可能.
// Product-axis radio (項目切替) controls table dimensions/metrics, not filter
// visibility.
export const buildAdebifyFilterKeySet = ({
  axis,
  currentTab,
}) => {
  return new Set([
    ...PRODUCT_FILTERS,
    ...(currentTab === TAB_ALL ? [FILTER_KEY_CHANNEL_DISPLAY] : []),
    ...(axis === PRIORITY_AXIS_EBIS ? ADEBIS_FILTERS : MEDIA_FILTERS),
  ]);
};

export const DEFAULT_ADEBIFY_AXIS = PRIORITY_AXIS_MEDIA_SYNC;
export const DEFAULT_ADEBIFY_PRODUCT_AXIS = 'ad_product';
